export default {
      id: "i-logo-small-usage",
      viewBox: "0 0 5750 5750",
      url: __webpack_public_path__ + "img/sprite.svg#i-logo-small",
      toString: function () {
        return this.url;
      }
    }